import "./App.css"
import React, { useState, useEffect } from "react"
import Pages from "./components/pages/Pages"
import { LoaderProvider } from "./context/LoaderContext"
import GlobalLoader from "./components/common/loader/GlobalLoader"

/**
 * App Component
 * Root component that wraps the application with LoaderProvider
 * and renders the GlobalLoader for API loading states
 */
function App() {
  // Local loading state managed via window events from request.js
  const [isLoading, setIsLoading] = useState(false)
  const [loadingCount, setLoadingCount] = useState(0)

  useEffect(() => {
    // Listen for loader events dispatched from request.js
    const handleShowLoader = () => {
      setLoadingCount(prev => prev + 1)
    }

    const handleHideLoader = () => {
      setLoadingCount(prev => Math.max(0, prev - 1))
    }

    window.addEventListener('loader:show', handleShowLoader)
    window.addEventListener('loader:hide', handleHideLoader)

    return () => {
      window.removeEventListener('loader:show', handleShowLoader)
      window.removeEventListener('loader:hide', handleHideLoader)
    }
  }, [])

  // Update isLoading based on count
  useEffect(() => {
    setIsLoading(loadingCount > 0)
  }, [loadingCount])

  return (
    <LoaderProvider>
      <GlobalLoader isLoading={isLoading} />
      <Pages />
    </LoaderProvider>
  )
}

export default App
